namespace Matrix.Data {
    export interface ClientFieldBatchDeleteRequest extends Serenity.ServiceResponse {
        RowIds?: number[];
    }
}
